import React, { useEffect, useRef } from 'react';

const Map = ({ markers = [], center, zoom = 10 }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const token = process.env.REACT_APP_MAPBOX_TOKEN;

  useEffect(() => {
    if (!containerRef.current || !token) return;

    const loadMap = async () => {
      const mapboxgl = (await import('mapbox-gl')).default;
      mapboxgl.accessToken = token;

      const first = markers[0] || { lat: 40, lng: -100 };
      const map = new mapboxgl.Map({
        container: containerRef.current,
        style: 'mapbox://styles/mapbox/light-v11',
        center: center || [first.lng, first.lat],
        zoom: zoom,
      });

      markers.forEach((m) => {
        new mapboxgl.Marker().setLngLat([m.lng, m.lat]).setPopup(new mapboxgl.Popup().setHTML(m.label || '')).addTo(map);
      });

      mapRef.current = map;
      return () => map.remove();
    };

    loadMap();
    return () => {
      if (mapRef.current) mapRef.current.remove();
    };
  }, [token, markers, center, zoom]);

  if (!token) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400">
        Map (set REACT_APP_MAPBOX_TOKEN)
      </div>
    );
  }

  return <div ref={containerRef} className="w-full h-full" />;
};

export default Map;
